import { render, staticRenderFns } from "./HeaderAndFooterEditor.vue?vue&type=template&id=852805d0&"
import script from "./HeaderAndFooterEditor.vue?vue&type=script&lang=ts&"
export * from "./HeaderAndFooterEditor.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderAndFooterEditor.vue?vue&type=style&index=0&id=852805d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports